<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">{{$t("stock_adjustment")}}</h4>
                <p class="text-subtitle-1">{{$t("list_of_stock_adjustment")}}</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="3" cols="12" v-if="hasPermission(permissions.stock_adjustment.create)">
                <v-btn color="primary" block @click="navigateToCreate">
                    <v-icon>mdi-plus</v-icon>
                    {{$t("Create_Inventory_Adjustment")}}
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            block
                            depressed
                            v-on="on"
                            v-bind="attrs"
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            {{$t("search")}}
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>{{$t("search")}}</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        :label="$t('code')"
                                        v-model="searchForm.code"
                                        outlined
                                        dense
                                        hide-details="auto"
                                        clearable

                                    >
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <DatePicker
                                        :label="$t('date_from')"
                                        v-model="searchForm.from"
                                        outlined
                                        dense
                                        hide-details
                                        clearable
                                        />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <DatePicker
                                        :label="$t('date_to')"
                                        v-model="searchForm.to"
                                        outlined
                                        dense
                                        hide-details
                                        clearable
                                        />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-autocomplete
                                        :label="$t('state')"
                                        v-model="searchForm.state_code"
                                        :items="states"
                                        item-value="id"
                                        item-text="name"
                                        outlined
                                        dense
                                        hide-details
                                        clearable>
                                        <template slot="item" slot-scope="{ item }">
                                            <PStatus :state="item.name">{{item.name}}</PStatus>
                                        </template>
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-row no-gutters>
                                <v-col>
                                    <v-btn  block color="primary" @click="handleSearch">
                                        {{$t("search")}}
                                    </v-btn>
                                </v-col>
                            </v-row>

                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-data-table
                    :items="items"
                    :headers="headers"
                    :loading="loading"
                    dense
                    :options.sync=options
                    :server-items-length="serverItemsLength"
                    :page.sync="page"
                >
                <template v-slot:[`item.code`]="{item}" v-if="hasPermission(permissions.stock_adjustment.read)">
                    <v-btn icon @click="navigateToRecord(item)">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    {{item.code}}
                </template>

                <template v-slot:[`item.state`]="{item}">
                    <PStatus :state="item.state"/>
                </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PStatus from './../../components/common/PStatus.vue';
import permissions from './../../data/permissions'
import stockAdjustment from "./../../services/stockJournal/stockAdjustment"
import DatePicker from '../../components/common/DatePicker.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        DatePicker,
        PStatus
    },
    data() {
        return {
            searchForm: {
                from : null,
                to: null,
                state: null,
                code: null
            },
            states: [
                { name: "Draft", id: 1},
                {name: "Pending", id: 2},
                { name: "Posted", id: 3},
                { name: "Rejected", id: 4 }

            ],
            items: [],
            warehouseId: null,
            footer: {
                'items-per-page-options': [10, 25, 50]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Reference", value: "reference" },
                { text: "Created By", value: "created_by" },
                { text: "State", value: "state" },
            ],
            loading: false,
            page: 1,
            serverItemsLength:0,
            options: {},
            permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    watch: {
        options: {
            deep: true,

            handler() {
                this.list()
            }
        }
    },
    methods: {
        list() {
            this.loading = true
            stockAdjustment.index({ warehouse_id : this.warehouseId , ...this.options, ...this.searchForm} )
            .then(res => {
                this.serverItemsLength = res.data.count
                this.items = res.data.data
            })
            .finally(() => {
                this.loading = false
            })
        },
        navigateToCreate() {
            this.$router.push({ name: "AdjustmentCreate"})
        },
        navigateToRecord(item) {
            this.$router.push({ name: "AdjustmentDisplay", params: { id:item.id }})

        },
        handleSearch() {
            this.options = {...this.options, ...this.form}
        }
    },
    mounted() {
        this.warehouseId = this.$route.params.warehouseId;
    }
}
</script>

<style>

</style>